<script setup lang="ts">
export interface IDSKInvitationTagProps {
  variant?: VyzvaPublicZoznamStavEnum
}
import { useI18n } from 'vue-i18n'
import { VyzvaPublicZoznamStavEnum } from '/@src/client-public'
import { formatVyzvaStav, formatZiadostStav } from '/@src/utils/format'

const CLASS_ROOT = 'idsk-invitation-tag'

const { t } = useI18n()

const props = withDefaults(defineProps<IDSKInvitationTagProps>(), {
  variant: VyzvaPublicZoznamStavEnum.Zverejnena,
})
</script>

<template>
  <IDSKTag :class="[CLASS_ROOT, 'vyzva-tag', `vyzva-tag--${props.variant}`]">
    {{
      formatVyzvaStav(props.variant) ?? formatZiadostStav(props.variant) ?? props.variant
    }}
  </IDSKTag>
</template>

<style scoped lang="scss">
.vyzva-tag {
  text-transform: none;
  letter-spacing: normal;
  padding-top: 3px;

  &--ZVEREJNENA,
  &--PREDLOZENA {
    background-color: var(--idsk-color-light-green);
  }

  &--ZRUSENA {
    background-color: var(--idsk-color-pink);
  }

  &--UZATVORENA,
  &--POZASTAVENA {
    background-color: var(--idsk-color-light-grey);
    color: var(--idsk-color-black);
  }

  &--PRIJATA,
  &--ZAEVIDOVANA_ISPO {
    background-color: var(--idsk-color-orange);
  }
}
</style>
